import { render, staticRenderFns } from "./brandbar.vue?vue&type=template&id=00d3dea4&scoped=true&"
import script from "./brandbar.vue?vue&type=script&lang=js&"
export * from "./brandbar.vue?vue&type=script&lang=js&"
import style0 from "./brandbar.vue?vue&type=style&index=0&id=00d3dea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d3dea4",
  null
  
)

export default component.exports